<template>
  <div>
    <iModal title="验证原邮箱" :closable="false" :mask-closable="false" v-model="showModal" class-name="vertical-center-modal" width="600px" @on-cancel="cancel" @on-visible-change="changeValidType">
      <div class="account-add" style="padding-right: 20px;">
        <!-- <p v-if="validType === 0">绑定新邮箱</p>
        <p v-if="validType === 1">验证旧邮箱</p>
        <p v-if="validType === 2">用新邮箱绑定旧邮箱</p>-->
        <div class="account-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="原邮箱：" prop="email">
              <Input type="text" v-model="formInline.email" placeholder="请输入邮箱号码" />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha">
              <Row>
                <Col span="14">
                <Input type="text" v-model="formInline.captcha" placeholder="请填写验证码" />
                </Col>
                <Col span="8" push="2">
                <Button v-if="showCode" @click="getCaptcha('formInline')" style="width: 100%;">获取验证码</Button>
                <Button v-else disabled style="width: 100%;">{{count}}s后重新获取</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="next('formInline')">下一步</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
    <iModal title="绑定新邮箱" :closable="false" :mask-closable="false" v-model="showModal2" class-name="vertical-center-modal" width="500px" @on-visible-change="changeValidType2">
      <div class="account-add">
        <!-- <p v-if="validType === 0">绑定新邮箱</p>
        <p v-if="validType === 1">验证旧邮箱</p>
        <p v-if="validType === 2">用新邮箱绑定旧邮箱</p>-->
        <div class="account-add-content">
          <Form ref="formInline2" :model="formInline2" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="新邮箱：" prop="email">
              <Input type="text" v-model="formInline2.email" placeholder="请输入邮箱" />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha">
              <Row>
                <Col span="14">
                <Input type="text" v-model="formInline2.captcha" placeholder="请填写验证码" />
                </Col>
                <Col span="8" push="2">
                <Button v-if="showCode" @click="getCaptcha('formInline2')" style="width: 100%;">获取验证码</Button>
                <Button v-else disabled style="width: 100%;">{{count}}s后重新获取</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading2" @click="bind('formInline2')">绑定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "changeEmail",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loading2: false,
      showModal: false,
      showModal2: false,
      email: "", // 邮箱
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      adminInfo: null, // 管理员信息
      timer: null,
      formInline: {
        email: "",
        captcha: "",
      },
      formInline2: {
        email: "",
        captcha: "",
      },
      ruleInline: {
        email: validator.email,
        captcha: [
          {
            required: true,
            message: "验证码为必填选项",
            trigger: "blur",
          },
        ],
      },
      validType: 0, // 三种状态 0：绑定新邮箱  1：验证原邮箱 2：绑定新邮箱
      firstToken: "", // 验证新邮箱之前的旧邮箱
    };
  },
  watch: {
    show(val, oldVal) {
      if (!this.email) {
        this.showModal2 = val;
      } else {
        this.showModal = val;
      }
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
    }),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",

      changeEmailToken: "companyModule/changeEmailToken", // （原邮箱不为空） 新邮箱发送验证码
      changeEmailOldToken: "companyModule/changeEmailOldToken", // （原邮箱不为空） 发送验证码
      changeEmailApply: "companyModule/changeEmailApply", // （原邮箱不为空） 验证并更改邮箱
      changeEmailOldCheck: "companyModule/changeEmailOldCheck", // （原邮箱不为空） 验证邮箱验证码（省略）

      bindEmailToken: "companyModule/bindEmailToken", // （原邮箱为空） 发送验证码
      bindEmailApply: "companyModule/bindEmailApply", // 验证并更改邮箱 绑定邮箱（原邮箱为空）
    }),
    async init() {
      let arr = [];
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach((c) => {
        if (c.userId === this.user.id) {
          this.adminInfo = c;
          this.email = c.email;
          if (!this.email) {
            this.validType = 0;
          } else {
            this.validType = 1;
          }
        }
      });
    },
    async bind() {
      // 绑定邮箱
      if (this.validType === 0) {
        this.bindNewEmail();
      }
      if (this.validType === 2) {
        this.bindNewEmailByOldEmail();
      }
    },
    async bindNewEmail() {
      // 绑定新邮箱
      let valid = await this.bindEmailApply({
        UserId: this.user.id,
        NewEmail: this.formInline2.email,
        token: this.formInline2.captcha,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return;
      }
      this.init();
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async bindNewEmailByOldEmail() {
      // 通过旧邮箱绑定新邮箱
      let valid = await this.changeEmailApply({
        UserId: this.user.id,
        OldEmail: this.email,
        NewEmail: this.formInline2.email,
        token: this.formInline2.captcha,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async next() {
      let form = this.formInline;
      let valid = await this.validForm("formInline");
      if (!valid) return;
      let bool = await this.changeEmailOldCheck({
        UserId: this.user.id,
        OldEmail: this.formInline.email,
        token: this.formInline.captcha,
      });
      if (!bool) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (!bool.successed) {
        this.$Message.error(bool.errors[0].description);
        this.formInline.captcha = "";
        return;
      }
      this.firstToken = this.formInline.captcha;
      this.$Message.success("验证成功!");
      // 验证原邮箱通过 跳到下一步
      this.showModal = false;
      this.showCode = true;
      clearInterval(this.timer);
      this.timer = null;
      this.formInline.captcha = "";
      this.formInline.captcha2 = "";
      this.showModal2 = true;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    getCaptcha(name) {
      this.$refs[name].validateField("email", (val) => {
        if (val !== "") return;
        this.downTime(name);
      });
    },
    async downTime(name) {
      let valid = null;
      if (this.validType === 0) {
        // 绑定新邮箱
        valid = await this.bindEmailToken({
          UserId: this.user.id,
          NewEmail: this.formInline2.email,
        });
      }
      if (this.validType === 1) {
        // 验证原邮箱
        valid = await this.changeEmailOldToken({
          UserId: this.user.id,
          OldEmail: this.formInline.email,
        });
      }
      if (this.validType === 2) {
        // 绑定新邮箱
        valid = await this.changeEmailToken({
          UserId: this.user.id,
          OldEmail: this.email,
          NewEmail: this.formInline2.email,
          token: this.firstToken,
        });
      }
      if (!valid.successed) {
        if (valid.msg) {
          this.$Message.error(valid.msg);
        } else {
          this.$Message.error(valid.errors[0].description);
        }
        return false;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    cancel() {
      this.showModal = false;
      this.showModal2 = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      if (this.$refs["formInline2"]) {
        this.$refs["formInline2"].resetFields();
      }
      this.firstToken = "";
      this.$emit("finish");
      this.$emit("close");
    },
    changeValidType2(bool) {
      if (bool) {
        if (!this.email) {
          this.validType = 0; // 绑定新邮箱
        } else {
          this.validType = 2; // 用新邮箱绑定旧邮箱
        }
      }
    },
    changeValidType(bool) {
      if (bool) {
        this.validType = 1; // 验证旧邮箱
      }
    },
  },
};
</script>

<style scoped lang="scss">
.account-add {
  padding-right: 20px;
  padding-top: 20px;
}
</style>

